import { MsalProvider } from "@azure/msal-react";
import { ThemeProvider } from "@mui/material";
import { LicenseInfo } from "@mui/x-license-pro";
import {
  GlobalTheme,
  QueryClientGlobal,
  MSALGlobal,
  MUILicenseKey,
} from "configs";
import {
  alert,
  AppNavigationProvider,
  DialogServiceProvider,
  UseAlert,
  UseConfirm,
} from "contexts";
import { AppInitializer, SurveyJSInitializer, AzureInitializer } from "libs";
import { ErrorBoundary } from "react-error-boundary";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import AppRoutes from "routes";
import store, { persistor } from "stores";

import "./index.scss";

if (process.env.NODE_ENV === "production" && MUILicenseKey) {
  LicenseInfo.setLicenseKey(MUILicenseKey);
}

const onErrorHandler = () =>
  alert({
    title: "Oops! Something went wrong",
    content: "Please reload and try again.",
    cancelLabel: "Reload",
    disableCloseOnBackdropAndEscape: true,
  }).then(() => window.location.reload());

function App() {
  return (
    <QueryClientProvider client={QueryClientGlobal as QueryClient}>
      <ReduxProvider store={store}>
        <MsalProvider instance={MSALGlobal}>
          <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={GlobalTheme}>
              <BrowserRouter>
                <AppNavigationProvider>
                  <DialogServiceProvider>
                    <ErrorBoundary
                      fallbackRender={() => null}
                      onError={onErrorHandler}
                    >
                      <ReactQueryDevtools />
                      <AppInitializer />
                      <AzureInitializer />
                      <SurveyJSInitializer />
                      <UseConfirm />
                      <UseAlert />
                      <AppRoutes />
                    </ErrorBoundary>
                  </DialogServiceProvider>
                </AppNavigationProvider>
              </BrowserRouter>
            </ThemeProvider>
          </PersistGate>
        </MsalProvider>
      </ReduxProvider>
    </QueryClientProvider>
  );
}

export default App;
